export type BugItem = {
  bugId: string;
  bugName: string;
  bugStatus: string;
  bugPriority: string;
  application: string | null;
  organization: string | null;
  createdDate: string | null;
  dueDate: string | null;
};

export type BugsFilters = {
  bugStatus: string | null;
  bugPriority: string | null;
  organization: string | null;
};

export type JiraFilterList = {
  statusList: string[];
  organizationList: string[];
  priorityList: string[];
};

export namespace BugsList {
  export type Response = {
    bugsList: BugItem[];
    totalRecords: string;
    sortingorder: string;
    sortingcolumn: string;
    size: string;
    offset: string;
  };
  export type Request = BugsFilters & {
    siteCode: string;
    appName: string;
    size: number;
    offset: number;
    sortingOrder: 'asc' | 'desc';
    sortingColumn: keyof BugItem;
  };
}

export namespace JiraIssue {
  export namespace IssueType {
    export type Bug = typeof Bug;
    export const Bug = { id: '10005' } as const;
  }

  export namespace Project {
    export type BugFixes = typeof BugFixes;
    export const BugFixes = { id: '10120' } as const;  
  }
  export namespace CustomField {
    export type ChangeMe = typeof ChangeMe;
    export const ChangeMe = { value: 'Change Me (Error Monitoring Default)' } as const;

    export type StrValue = {
      value: string;
      child: {
        value: string;
      };
    };
  }

  export namespace CreateBug {
    export type Fields = {
      summary: string;
      issuetype: IssueType.Bug;
      project: Project.BugFixes;
      customfield_10060: CustomField.StrValue | CustomField.ChangeMe;
      customfield_10062: CustomField.ChangeMe;
      reporter: {id : string}
    };

    export type Params = {
      userEmailId: string;
    };

    export type Request = {
      fields: Fields;
    };

    export type SuccessMessages = {
      id: string;
      key: string;
      self: string;
    };
    
    export type Response = {
      successMessages: string;
    };
  }
}
